<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="800"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="告警配置"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="iotplt-compact-form"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 15 }"
          :form="form"
          @submit="handleSubmit"
        >
          <a-form-item
            label="告警方式"
          >
            <a-radio-group
              v-decorator="['is_alarm',{
                rules: [
                  { required: true, message: '请选择告警方式' },
                ],
                initialValue: isAlarm
              }]"
            >
              <a-row style="margin-top: 10px">
                <a-col :span="8">
                  <a-radio :value="false">
                    不发送告警
                  </a-radio>
                  <a-radio
                    :value="true"
                    class="vertical-radio"
                  >
                    告警触发条件
                  </a-radio>
                </a-col>
              </a-row>
            </a-radio-group>

            <a-form-item
              class="limit-type-setting-box"
              v-if="isShowAlarmTypeSetting"
            >
              <a-radio-group
                v-decorator="['alarm_type',{
                  rules: [
                    { required: true, message: '请配置告警方式' },
                  ],
                  initialValue: alarmType || 1
                }]"
              >
                <a-row>
                  <a-radio
                    style="margin-top: 8px;"
                    :value="1"
                  >
                    库存数量低于
                  </a-radio>

                  <a-form-item
                    :style="{ display: 'inline-block', marginBottom: 0 }"
                  >
                    <a-input-number
                      :min="0"
                      :max="1000000"
                      :step="1"
                      :precision="0"
                      style="width: 150px;"
                      v-decorator="['alarm_value', {
                        rules: [
                          { required: true, message: '请输入阈值' },
                        ],
                        initialValue: alarmValue
                      }]"
                    />
                  </a-form-item>
                </a-row>
              </a-radio-group>
            </a-form-item>
          </a-form-item>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { setModuleInventoryAlarm } from '@/api/module_inventory'

export default {
  name: 'ModuleInventorySetAlarm',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    moduleModelId: {
      type: Number,
      required: true
    },
    isAlarm: {
      type: Boolean,
      required: true
    },
    alarmType: {
      type: Number,
      required: true
    },
    alarmValue: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'set_module_inventory_alarm', onValuesChange: this.onValuesChange }),
      isShowAlarmTypeSetting: false,
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    setTimeout(() => {
      this.form.setFieldsValue({
        is_alarm: this.isAlarm
      })

      if (this.isAlarm) {
        this.isShowAlarmTypeSetting = true
        this.form.setFieldsValue({
          alarm_type: this.alarmType || 1,
          alarm_value: this.alarmValue
        })
      }
    }, 200)
  },
  methods: {
    onValuesChange(props, values) {
      if (values.is_alarm !== undefined) {
        this.clearAlarmValueSetting()
        this.isShowAlarmTypeSetting = values.is_alarm
      }

      if (values.alarm_type !== undefined) {
        this.clearAlarmValueSetting()
      }
    },

    clearAlarmValueSetting() {
      this.form.setFieldsValue({
        alarm_value: undefined
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const data = {
            ...values
          }

          setModuleInventoryAlarm(this.moduleModelId, data).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
              this.$success({
                title: '提交成功',
                content: (
                  <div>
                    <p>操作成功</p>
                  </div>
                )
              })
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.vertical-radio {
  margin-top: 8px;
}

.limit-type-setting-box {
  margin-left: 30px;
  margin-top: -10px;
}
</style>
